import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import React, { Component } from "react";
import { I8N } from "@eres/core";
import Strings from "@my-dld/assets/strings";


interface Props {
	rankingDetails: any;
}

interface State {
	property: AssetCard;
	classificationInfo?: any;
	classificationDetails: any[];
	year: any;
}

class VCRankingItem extends Component<Props, State> {

	render() {
		let detail = this.props.rankingDetails;
		let standardName = I8N.isRTL() ? detail.classificationDetails[ 0 ].StandardNameAr : detail.classificationDetails[ 0 ].StandardNameEn;

		return <React.Fragment>
			<div className="col-md-12">
				<div className="section-title">
					<h5>{ standardName }</h5>
				</div>
				<div className="flex-grid">
					<div>
                        <span>
                            <strong>{ Strings.standard }</strong>
                        </span>
						<span>
                            <strong>{ Strings.points }</strong>
                        </span>
					</div>

					{ detail.classificationDetails!.map( ( rankDetail: any, index: number ) => {
						return this.renderRow( rankDetail );
					} ) }
				</div>
			</div>
		</React.Fragment>;
	}

	renderRow( detail: any ) {
		let subStandardName = I8N.isRTL() ? detail.SubStandardNameAr : detail.SubStandardNameEn;
		let value = detail.ClassificationValue ? detail.ClassificationValue : "0 ";
		return <React.Fragment>
			<div>
				<span>{ subStandardName }</span>
				<span>{ value }</span>
			</div>
		</React.Fragment>;
	}
}

export default VCRankingItem;
